import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "filters-group",
  class FiltersGroup extends WYATTElement {
    constructor() {
      super({
        openAttribute: "open",
        itemSelector: ".filters__item",
        toggleButtonSelector: "[data-filters-group-toggle]",
      });

      this.toggleButton = this.querySelector(this.config.toggleButtonSelector);
      this.items = this.querySelectorAll(this.config.itemSelector);
      this.toggleButton?.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick() {
      if (this.hasAttribute(this.config.openAttribute)) {
        this.close();
      } else {
        this.open();
      }
    }

    close() {
      this.removeAttribute(this.config.openAttribute);
    }

    open() {
      const inputToFocus =
        this.items[this.config.collapsedSize].querySelector("input");
      this.setAttribute(this.config.openAttribute, true);
      inputToFocus.focus();
    }
  }
);
